import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DynamicFormService {
  private readonly fillInFormSubject$ = new Subject<void>();
  private readonly autosavingSubject$ = new BehaviorSubject<boolean>(false);

  public autosaving$ = this.autosavingSubject$.asObservable();

  public onFillInForm(): Observable<void> {
    return this.fillInFormSubject$.asObservable();
  }

  public triggerFillInForm(): void {
    this.fillInFormSubject$.next();
  }

  public setAutosaving(value: boolean): void {
    this.autosavingSubject$.next(value);
  }
}

